// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetClinicAndHomeProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/prescriptions/clinic_&_home", false, /\.(png|jpe?g|svg)$/)
  );

  const fullBodyProtocolsImg = importImages(
    require.context("../../../../assets/images/protocols/prescriptions/web/fullBody", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.clinicAndHome.SPHEROIDS.id]: {
      img: protocolImg["./spheroids.png"],
      name: "spheroids",
    },
    [protocols.clinicAndHome.PINBALL.id]: {
      img: protocolImg["./pinball.png"],
      name: "pinball",
    },
    [protocols.clinicAndHome.HOCKEY.id]: {
      img: protocolImg["./hockey.png"],
      name: "hockey",
    },
    [protocols.clinicAndHome.CLEAN_THE_TABLE.id]: {
      img: protocolImg["./clean_the_table.png"],
      name: "cleanTheTable",
    },
    [protocols.clinicAndHome.GRASP_AND_PLACE.id]: {
      img: protocolImg["./grasp_and_place.png"],
      name: "graspAndPlace",
    },
    [protocols.clinicAndHome.FOLLOW_THE_LINE.id]: {
      img: protocolImg["./follow_the_line.png"],
      name: "followTheLine",
    },
    [protocols.clinicAndHome.ROAD_TRIP.id]: {
      img: protocolImg["./roadtrip.png"],
      name: "roadTrip",
    },
    [protocols.clinicAndHome.BRICKS.id]: {
      img: protocolImg["./bricks.png"],
      name: "bricks",
    },
    [protocols.clinicAndHome.BOAT.id]: {
      img: protocolImg["./boat.png"],
      name: "boat",
    },
    [protocols.clinicAndHome.BUBBLES.id]: {
      img: protocolImg["./bubbles.png"],
      name: "bubbles",
    },
    [protocols.clinicAndHome.DEMOLITION.id]: {
      img: protocolImg["./demolition.png"],
      name: "demolition",
    },
    [protocols.clinicAndHome.CATERING.id]: {
      img: protocolImg["./catering.png"],
      name: "catering",
    },
    [protocols.clinicAndHome.CONSTELLATIONS.id]: {
      img: protocolImg["./constellations.png"],
      name: "constellations",
    },
    [protocols.clinicAndHome.TWISTER_BUDDY.id]: {
      img: fullBodyProtocolsImg["./twisterBuddy.png"],
      name: "twisterBuddy",
    },
    [protocols.clinicAndHome.COSTUME_PARTY.id]: {
      img: fullBodyProtocolsImg["./costumeParty.png"],
      name: "costumeParty",
    },
    [protocols.clinicAndHome.GENTLE_GIANT.id]: {
      img: fullBodyProtocolsImg["./gentleGiant.png"],
      name: "gentleGiant",
    },
  };

  return protocolsData[Number(protocolId)];
};
